import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';


interface Props {
  children: React.ReactNode;
}

const RoleBasedRoute: React.FC<Props> = ({ children }) => {
  const { role, loading } = useAuth();

  // Show loading while auth context is still loading
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#f9f9fb] to-[#f1f2f6] flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
            <div className="animate-spin w-8 h-8 border-2 border-indigo-600 border-t-transparent rounded-full"></div>
          </div>
          <p className="text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect based on user role
  switch (role) {
    case 'waitlisted':
      return <Navigate to="/the-gallery" replace />;
    case 'viewer':
    case 'admin':
    case 'creator':
      return <>{children}</>;
    default:
      // For users without a role or unknown roles, redirect to unauthorized
      return <Navigate to="/unauthorized" replace />;
  }
};

export default RoleBasedRoute; 